import React, {
  FunctionComponent,
  MouseEventHandler,
  ReactElement,
} from "react"
import RightArrow from "../assets/rightArrow"
import { AmplitudeEvents } from "../types/amplitudeEvents"

export enum FeaturesVerticalContentType {
  Details = "feature-content",
  Banner = "feature-banner",
}

export interface FeaturesVerticalContent {
  icon?: ReactElement
  header?: ReactElement
  subtext?: string
  featureVClassName?: FeaturesVerticalContentType | string
  btnTxt?: string
  btnColor?: string
  bannerSrc?: string
  handlebtn?: string
  floatingScribble?: {
    position: "top" | "bottom"
    icon: ReactElement
  }
}

interface FeaturesVerticalProps {
  content: [FeaturesVerticalContent, FeaturesVerticalContent][]
  onClickJoinDashboard: any
  onClickJoinSocial: any
}

const FeaturesVertical: FunctionComponent<FeaturesVerticalProps> = ({
  content = [],
  onClickJoinDashboard,
  onClickJoinSocial,
}) => {
  const returnFeatureContentElement = (
    ele: FeaturesVerticalContent,
    ind: number
  ) => {
    if (ele.featureVClassName === FeaturesVerticalContentType.Details) {
      return (
        <div className="feature-content">
          {ele.icon}

          {ele.floatingScribble?.position === "top" && (
            <div className="orange-scribble">{ele.floatingScribble?.icon}</div>
          )}

          {ele.floatingScribble?.position === "bottom" && (
            <div className="red-scribble">{ele.floatingScribble?.icon}</div>
          )}

          <h3 className="feature-title h2Text">{ele.header}</h3>

          <p className="feature-description body-txt">{ele.subtext}</p>

          <button
            onClick={ele.handlebtn === "ToDashboard" ? onClickJoinDashboard: onClickJoinSocial}
            className={`txtBtn-with-arrow-section txt-btn body-txt ${
              ele.btnColor || "red"
            }-txtBtn`}
          >
            <p>{ele.btnTxt}</p>
            <RightArrow color={`var(--theme-${ele.btnColor || "red"})`} />
          </button>
        </div>
      )
    } else if (ele.featureVClassName === FeaturesVerticalContentType.Banner) {
      return (
        <div className="feature-banner">
          <img
            className={`banner-${ind + 1}-rotate`}
            alt="Banner image for the feature section 1"
            src={ele.bannerSrc}
          />
        </div>
      )
    }
  }

  return (
    <div className="features-section">
      {content.map((val, ind) => (
        <div key={ind} className={`feature-container feature-${ind + 1}`}>
          {returnFeatureContentElement(val[0], ind)}
          {returnFeatureContentElement(val[1], ind)}
        </div>
      ))}
    </div>
  )
}

export default FeaturesVertical
